export enum AddToCartButtonType {
  ADD_TO_CART_BUTTON = 'ADD_TO_CART_BUTTON',
  ADD_TO_CART_BUTTON_WITHSTEPPER = 'ADD_TO_CART_BUTTON_WITHSTEPPER',
  ADD_TO_LIST_BUTTON = 'ADD_TO_LIST_BUTTON',
  ADD_TO_CART_WITH_SUBSCRIBE = 'ADD_TO_CART_WITH_SUBSCRIBE',
}
